import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import Newssyle from "./Newssyle";
import {
  FaHandsHelping,
  FaHeart,
  FaUsers,
  FaFileAlt,
  FaCheckCircle,
  FaHome,
  FaUserFriends,
  FaSeedling,
  FaStar,
  FaQuoteLeft,
  FaLeaf,
} from "react-icons/fa";
import "./News.css";

const FEATURE_CARDS = [
  {
    icon: FaHandsHelping,
    title: "Volunteer",
    text: "Be a part of our mission and contribute your time to bring positive change.",
  },
  {
    icon: FaHeart,
    title: "Love and Action",
    text: "Small acts of kindness can create a big impact, join us in spreading love and hope.",
  },
  {
    icon: FaUsers,
    title: "Join Us & Support",
    text: "Your support helps us reach more lives and build stronger communities.",
  },
];

const STATS = [
  { icon: FaUsers, value: "796,128", label: "Life Touched", color: "#7c5cf0" },
  { icon: FaFileAlt, value: "17", label: "Zones", color: "#2563eb" },
  { icon: FaCheckCircle, value: "48", label: "Blocks", color: "#2b9348" },
  { icon: FaHome, value: "20,890", label: "Panchayats", color: "#f2622e" },
  { icon: FaUserFriends, value: "2,690,020", label: "Population", color: "#eab308" },
];

const JOURNEY_POINTS = [
  {
    icon: FaUsers,
    title: "Community Driven",
    text: "Empowering communities to create lasting change.",
  },
  {
    icon: FaHeart,
    title: "Transparency",
    text: "We operate with honesty and accountability.",
  },
  {
    icon: FaSeedling,
    title: "Sustainable Impact",
    text: "Building solutions that last for generations.",
  },
  {
    icon: FaStar,
    title: "Inclusive Growth",
    text: "Leaving no one behind in our journey of progress.",
  },
];

const News = () => {
  return (
    <>
      <Header />

      {/* ================= Hero (1521 x 482) ================= */}
      <section className="nw-page">
        <div className="nw-container">
          <div className="nw-hero">
            <div
              className="nw-hero__image"
              style={{ backgroundImage: "url(/assets/images/backgrounds/News.jpg)" }}
            />
            <div className="nw-hero__overlay" />
            <div className="nw-hero__content">
              <h2 className="wow fadeInDown nw-hero__title" data-wow-duration="1500ms">
                News
              </h2>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid p-0">
        {/* ================= Feature cards ================= */}
        <section className="nw-features">
          <div className="container text-center">
            <h2 className="nw-heading">Are You Ready to Build a Better Society?</h2>
            <span className="nw-heading__underline" />

            <div className="row g-4 mt-2">
              {FEATURE_CARDS.map((card) => {
                const Icon = card.icon;
                return (
                  <div className="col-md-4" key={card.title}>
                    <div className="nw-featureCard">
                      <span className="nw-featureCard__icon">
                        <Icon />
                      </span>
                      <h5 className="nw-featureCard__title">{card.title}</h5>
                      <p className="nw-featureCard__text">{card.text}</p>
                      <a href="#" className="nw-featureCard__btn">
                        Get Involved
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* ================= Stats bar ================= */}
            <div className="nw-statsBar">
              {STATS.map((s) => {
                const Icon = s.icon;
                return (
                  <div className="nw-statsBar__item" key={s.label}>
                    <span className="nw-statsBar__icon" style={{ color: s.color, background: `${s.color}1A` }}>
                      <Icon />
                    </span>
                    <div>
                      <div className="nw-statsBar__value">{s.value}</div>
                      <div className="nw-statsBar__label">{s.label}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* ================= News & Events (rendered by Newssyle) ================= */}
        <Newssyle />

        {/* ================= Our Journey ================= */}
        <section className="nw-journey">
          <div className="container">
            <div className="nw-journey__header">
              <span className="nw-eyebrow">
                <FaLeaf /> Our Journey
              </span>
              <h2 className="nw-journey__title">A Journey of Impact & Change</h2>
            </div>

            <div className="nw-journey__videoWrap">
              <div className="ratio ratio-16x9">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/PoQp8NrwFXw?si=XMPYCy_9xd19TRWK"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className="nw-journey__quote">
              <FaQuoteLeft className="nw-journey__quoteIcon" />
              <p>
                Together we move forward, creating a brighter and better
                tomorrow.
              </p>
            </div>

            <div className="nw-journey__points">
              {JOURNEY_POINTS.map((p) => {
                const Icon = p.icon;
                return (
                  <div className="nw-journey__point" key={p.title}>
                    <span className="nw-journey__pointIcon">
                      <Icon />
                    </span>
                    <h6>{p.title}</h6>
                    <p>{p.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </div>

      <Footer />
      {/* /.page-wrapper */}
      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};
export default News;